var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-view":""}},[_c('Banner'),_c('SearchQueryResults'),(_vm.relatedQueries)?_c('RelatedSearchQuery',{attrs:{"related-queries":_vm.relatedQueries}}):_vm._e(),_c('Benefits')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }